var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"permission-auth",attrs:{"role":"group"}},[(_vm.show())?_vm._t("default",null,{"disabledByPermission":!_vm.hasPermission()}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }